import { watch } from "vue"
import useFilterStore from "@/stores/filterStore.js"

export default function usePortfolioAsDefaultMeteringPoint(changeOnRoles = []) {
  const filterStore = useFilterStore()

  // Default to the portfolio as soon as one is available. A `watch` (rather
  // than `onBeforeMount`) also covers the case where the portfolio is still
  // loading at mount time and only resolves afterwards.
  watch(
    () => filterStore.currentPortfolio,
    (portfolio) => {
      if (
        portfolio &&
        (!filterStore.currentMeteringPoint ||
          changeOnRoles.includes(filterStore.currentMeteringPoint?.role))
      ) {
        filterStore.setMeteringPoint(portfolio)
      }
    },
    { immediate: true },
  )
}
